var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"px-5"},[_c('v-row',[(_vm.html[_vm.id])?_c('v-col',{domProps:{"innerHTML":_vm._s(_vm.html[_vm.id])}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }